import * as yup from "yup";
import { Box, Button, Grid, Typography, Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller } from 'react-hook-form';
import CloseIcon from "@mui/icons-material/Close";
import DatePickerMui from "../../../../components/hookForms/datePicker";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { format } from "date-fns";
import messages from "../../../../utils/messages";
import serviceFaturaCliente from "../../../../services/serviceFaturaCliente";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../../../context/global";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    data: {
        open: boolean;
        id: string;
        dataVencimentoFatura: Date;
        nomeCliente: string;
        flagCancelada?: string;
        statusFatura?: string
    };
    onClose?: any;
}

export default function DialogEdit({ open, data, onClose, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);
    const { handleGetDataUser } = useAuth();
    const user = handleGetDataUser();
    const isAdmin = user.perfil === "Admin";



    const validationSchema = yup.object().shape({
        dataVencimentoFatura: yup.date().required(messages.requiredField).typeError(messages.invalidDate),
        flagCancelada: yup
            .object()
            .shape({
                label: yup.string().required(),
                value: yup.string().required(),
            })
            .nullable(),

        motivoCancelamento: yup
            .string()
            .when("flagCancelada", {
                is: (value) => value?.value !== data.flagCancelada,
                then: (schema) => schema.required("Informe o motivo da alteração."),
                otherwise: (schema) => schema.notRequired(),
            }),
    });
    const Cancelada = [
        { label: "Sim", value: "Sim" },
        { label: "Não", value: "Não" },

    ];
    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        watch,
    } = useForm({
        resolver: yupResolver(validationSchema),
        shouldUnregister: false, 
        defaultValues: {
            dataVencimentoFatura: new Date(),
            idFaturaCliente: "",
            nomeCliente: "",
            flagCancelada: data.flagCancelada === "Sim"
                ? { label: "Sim", value: "Sim" }
                : { label: "Não", value: "Não" },
            statusFatura: "",
            motivoCancelamento: "",
        },
    });

    const flagCanceladaAtual = watch("flagCancelada");
    const flagCanceladaOriginal = data.flagCancelada;
    const flagCanceladaAlterada = flagCanceladaAtual?.value !== flagCanceladaOriginal;

    useEffect(() => {
        if (data) {
            reset({
                ...data,
                idFaturaCliente: data.id, // se necessário renomear
                flagCancelada: data.flagCancelada === "Sim"
                    ? { label: "Sim", value: "Sim" }
                    : { label: "Não", value: "Não" },

            });
        }
    }, [data, reset]);


    const onSubmit = (values: any) => {
        setDisable(true);

        const updateValues: any = {
            faturaClienteID: data.id,
        };
        if (
            values.dataVencimentoFatura &&
            format(values.dataVencimentoFatura, "yyyy-MM-dd") !== format(data.dataVencimentoFatura, "yyyy-MM-dd")
        ) {
            updateValues.dataVencimentoFatura = format(values.dataVencimentoFatura, "yyyy-MM-dd");
        }
        if (values.flagCancelada?.value !== data.flagCancelada) {
            updateValues.flagCancelada = values.flagCancelada?.value;
            updateValues.motivo = values.motivoCancelamento;
        }

        serviceFaturaCliente
            .update(updateValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onClose(true);
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };


    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Editar Fatura
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Box>
                        <Typography variant="subtitle1">Fatura Cliente ID: {data.id}</Typography>
                        <Typography variant="subtitle1">Cliente: {data.nomeCliente}</Typography>

                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12}>
                                <DatePickerMui
                                    name="dataVencimentoFatura"
                                    label="Data de Vencimento"
                                    control={control}
                                    error={errors}
                                    noDateForward={false}
                                    disabled={data.statusFatura === "Publicada" && isAdmin}
                                />
                            </Grid>

                            {isAdmin && (
                                <>
                                    <Grid item xs={12} md={12}>
                                        <Controller
                                            name="flagCancelada"
                                            control={control}
                                            render={({ field }) => (
                                                <Autocomplete
                                                    {...field}
                                                    options={Cancelada}
                                                    getOptionLabel={(option) => option.label}
                                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                                    onChange={(_, value) => field.onChange(value)}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Cancelada"
                                                            error={!!errors.flagCancelada}
                                                            helperText={errors.flagCancelada?.message}
                                                            fullWidth
                                                        />
                                                    )}
                                                    disabled={!(data.statusFatura === "Publicada" || data.statusFatura === "Aberta")}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    {flagCanceladaAlterada && (
                                        <Grid item xs={12} md={12}>
                                            <Controller
                                                name="motivoCancelamento"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        label="Descreva o motivo da alteração da FlagCancelada"
                                                        error={!!errors.motivoCancelamento}
                                                        helperText={errors.motivoCancelamento?.message}
                                                        fullWidth
                                                        multiline
                                                        rows={3}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    )}

                                </>
                            )}


                        </Grid>

                    </Box>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
